import React, { useRef, useState } from "react";
import {
  ListSubheader,
  Stack,
  ListItem,
  ListItemButton,
  ListItemText,
  Button,
  Modal,
  Box,
  Typography,
  IconButton,
  Card,
  List
} from "@mui/material";
import SearchField from "./SearchField";
import { Postrequestcall } from "../../request/Postrequest";
import { FETCH_COMPANIES, FETCH_COMPANIES_2, SAVE_COMPANIES, SAVE_PRODUCTS } from "../../constant/Apipath";
import { useSelector } from "react-redux";
import Loader from "../../common/Loader";
import { useNavigate } from "react-router-dom";
import Removeduplicates from "./Removeduplicate";
import CloseIcon from "@mui/icons-material/Close";
import { English } from "../../constant/EnglishFallback";

const AddManufactureModal = ({ open, onClose, from, productDetails, onDataSave }) => {
  const { loginData, multiLanguageData } = useSelector((state) => state?.main);
  const currentUserId = loginData?.userInformation?.UserId ?? 0;
  const debounceTimeout = useRef(null);
  let navigate = useNavigate();
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [showSubmitLoading, setShowSubmitLoading] = useState(false);

  const {
    TEXT_ADD_MANUFACTURER = English?.AddManufactureModal?.TEXT_ADD_MANUFACTURER,
    TEXT_MANUFACTURER_PLACEHOLDER = English?.AddManufactureModal?.TEXT_MANUFACTURER_PLACEHOLDER,
    BUTTON_ADD = English?.AddManufactureModal?.BUTTON_ADD,
    TEXT_EXISTING_MANUFACTURES = English?.AddManufactureModal?.TEXT_EXISTING_MANUFACTURES,
    BUTTON_VIEW = English?.AddManufactureModal?.BUTTON_VIEW
  } = multiLanguageData?.AddManufactureModal || {};

  const getData = async (searchTerm) => {
    try {
      setIsLoading(true);
      
      // OLD API: FETCH_COMPANIES (commented, do not delete)
      // const obj = {
      //   PageNr: 1,
      //   NrOfRecPerPage: 20,
      //   IncludeRecordNr: true,
      //   SearchList: [
      //     {
      //       name: searchTerm,
      //       manufacturer: true
      //     }
      //   ],
      //   SortList: [{ FieldName: "Name", Direction: "ASC" }],
      //   FetchAllowedRecordsOnly: true,
      //   DoNotSearchInSystemFields: true
      // };
      // const res = await Postrequestcall(FETCH_COMPANIES, obj, loginData?.accessToken);
      
      // NEW API: FETCH_COMPANIES_2 (active)
      const obj = {
        UserId: currentUserId,
        SearchString: searchTerm,
        PageNumber: 1,
        PageSize: 20,
        Manufacturer: true,
        Id: 0
      };
      const res = await Postrequestcall(FETCH_COMPANIES_2, obj, loginData?.accessToken);
      let resData = res?.data?.data ?? [];
      const updatedCode = await Removeduplicates(resData, "name");
      setData(() => updatedCode);
    } catch (error) {
      console.log("getData-> Error When Fetching Companies: ", error);
    } finally {
      setIsLoading(false);
    }
  };

  const showAddBtn = (value) => {
    const searchData = data.filter((i) => i.name.toUpperCase() === value.toUpperCase());
    return searchData?.length === 0 ? true : false;
  };

  const onViewClick = (item) => {
    navigate(`/manufacture/${item?.id}`);
  };

  const handleAddNewManfacture = async () => {
    try {
      setShowSubmitLoading(true);
      const saveObject = {
        userId: Number(currentUserId),
        ReturnRecordId: true,
        ReturnRecordError: true,
        SaveList: [
          {
            Id: 0,
            Name: searchTerm,
            ModifiedBy: Number(currentUserId),
            RecordStatusId: 1,
            Manufacturer: true
          }
        ]
      };
      let res = await Postrequestcall(SAVE_COMPANIES, saveObject, loginData?.accessToken);
      if (from === "productProfile") {
        let newManufacturerDetails = res?.data?.data?.[0]?.objData;
        await handleAddExistingManfacture(newManufacturerDetails);
      } else {
        const id = res?.data?.data[0].objData?.id;
        navigate(`/manufacture/${id}`);
        setShowSubmitLoading(false);
        onClose();
      }
    } catch (error) {
      console.log("handleAddNewManfacture-> Error When Saving New Companie: ", error);
    }
  };

  const handleAddExistingManfacture = async (item) => {
    if (from !== "productProfile") {
      return null;
    }
    try {
      const saveObject = {
        userId: Number(currentUserId),
        ReturnRecordId: true,
        ReturnRecordError: true,
        SaveList: [
          {
            Id: productDetails?.id,
            Name: productDetails?.name,
            webSite: productDetails?.productWebSite,
            Info: productDetails?.info,
            productType: productDetails?.productType,
            ManufacturerId: item?.id ?? 0,
            ModifiedBy: Number(currentUserId),
            RecordStatusId: 1
          }
        ]
      };
      await Postrequestcall(SAVE_PRODUCTS, saveObject, loginData?.accessToken);
      onDataSave();
    } catch (error) {
      console.log("handleAddExistingManfacture-> Error When Saving Product: ", error);
    } finally {
      onClose();
    }
  };

  return (
    <Modal open={open}>
      <Box className="user-modal-responsive">
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between"
          }}>
          <Typography variant="h6">{TEXT_ADD_MANUFACTURER}</Typography>
          <IconButton onClick={() => onClose()}>
            <CloseIcon />
          </IconButton>
        </Box>

        <SearchField
          value={searchTerm}
          onChange={(value) => {
            setIsLoading(true);
            const searchValue = value;
            setSearchTerm(searchValue);
            if (debounceTimeout.current) {
              clearTimeout(debounceTimeout.current);
            }
            debounceTimeout.current = setTimeout(() => {
              getData(value, 1);
            }, 1000);
          }}
          onSubmit={() => {
            setSearchTerm(searchTerm);
            getData(searchTerm, 1);
          }}
          placeholder={TEXT_MANUFACTURER_PLACEHOLDER}
          size={"small"}
        />
        <Box
          sx={{
            marginTop: "10px",
            paddingBottom: "10px",
            height: "450px",
            overflow: "auto",
            scrollbarWidth: "none"
          }}>
          {isLoading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                height: 450
              }}>
              <Loader />
            </div>
          ) : (
            <>
              {searchTerm.trim().length > 1 && showAddBtn(searchTerm) && (
                <Card className="pagelist-content" sx={{ marginBottom: 1 }}>
                  <ListItem
                    secondaryAction={
                      <Button
                        loading={showSubmitLoading}
                        color="primary"
                        variant="contained"
                        size="small"
                        onClick={handleAddNewManfacture}>
                        {BUTTON_ADD}
                      </Button>
                    }>
                    <ListItemText primary={searchTerm} />
                  </ListItem>
                </Card>
              )}

              {searchTerm !== "" && (
                <>
                  {data.length > 0 && (
                    <List disablePadding>
                      <ListSubheader sx={{ pl: 0 }}>{TEXT_EXISTING_MANUFACTURES}</ListSubheader>
                      <Stack sx={{ gap: 1 }} >
                        {data?.map((item, index) => {
                          return (
                            <Card key={index.toString()} className="pagelist-content">
                              <ListItem
                                key={index.toString()}
                                secondaryAction={
                                  from !== "productProfile" && (
                                    <Button
                                      color="primary"
                                      variant="outlined"
                                      size="small"
                                      onClick={() => onViewClick(item)}>
                                      {BUTTON_VIEW}
                                    </Button>
                                  )
                                }
                                disablePadding>
                                <ListItemButton
                                  onClick={() => {
                                    from === "productProfile"
                                      ? handleAddExistingManfacture(item)
                                      : onViewClick(item);
                                  }}>
                                  <ListItemText primary={item?.name} />
                                </ListItemButton>
                              </ListItem>
                            </Card>
                          );
                        })}
                      </Stack>
                    </List>
                  )}
                </>
              )}
            </>
          )}
        </Box>
      </Box>
    </Modal>
  );
};

export default AddManufactureModal;

